// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__Ulx4W","absolute":"accordion_absolute__stkLb","open":"accordion_open__6Fv3Z"};